import React from 'react';
import AboutUs from '../../components/AboutUs/AboutUs';
import LandingHeader from '../../components/LandingHeader/LandingHeader';
import Education from '../../components/Education/Education';
import Pricing from '../../components/Pricing/Pricing';
import Footer from '../../components/Footer/Footer';

import classes from './Home.module.css';

const Home = () => {
    return (
        <div className={classes.landing_page__container}>
            <section className={classes.full_screen} id='hero'>
                <LandingHeader />
            </section>
            <section className={classes.full_screen} id='about_us'>
                <AboutUs />
            </section>
            <section className={`${classes.full_screen} ${classes.white_bg}`} id='education'>
                <Education />
            </section>
            <section className={`${classes.full_screen} ${classes.mobile_show_hidden}`} id='whats_new'>
                <Pricing />
            </section>
            <footer className={classes.footer} id='footer'>
                <Footer />
            </footer>
            {/* <div id='go_top'>
                TOP
            </div> */}
        </div>
    );
};

export default Home;
